// extracted by mini-css-extract-plugin
export default {"ulstyle":"Navbar_ulstyle__lwVNg","colored":"Navbar_colored__Obo7t","bigScreenNavbar":"Navbar_bigScreenNavbar__U+4GV"};